import {chooseStands} from './teaballs-cart-stands-plan.js';
let busy = false;
class TeaballsCartStands extends HTMLElement {
 connectedCallback() {
  this.abort?.abort(); this.abort = new AbortController();
  this.configNode = this.querySelector('[data-stand-config]');
  this.config = JSON.parse(this.configNode.textContent);
  this.cart = this.config.cart;
  this.input = this.querySelector('[data-stand-check]');
  this.input.addEventListener('change',()=>this.add(),{signal:this.abort.signal});
  document.addEventListener('cart:updated',e=>{if(e.detail?.items){this.cart=e.detail;this.render();}},{signal:this.abort.signal});
  document.addEventListener('teaballs:bf-pricing:change',()=>this.render(),{signal:this.abort.signal});
  this.observer = new MutationObserver(()=>{this.config=JSON.parse(this.configNode.textContent);this.cart=this.config.cart;this.render();});
  this.observer.observe(this.configNode,{childList:true,characterData:true,subtree:true});
  this.render();
 }
 disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();}
 get labels(){return this.config.labels;}
 plan(cart) {
  const ids=new Set(this.config.bottles.map(String));
  const bottles=cart.items.reduce((n,i)=>n+(ids.has(String(i.variant_id))?i.quantity:0),0);
  let capacity=0, threeOwned=0, fiveOwned=0;
  for(const i of cart.items){if(String(i.variant_id)===String(this.config.three.id))threeOwned+=i.quantity;if(String(i.variant_id)===String(this.config.five.id))fiveOwned+=i.quantity;}
  capacity=threeOwned*3+fiveOwned*5;
  const bf=window.TeaballsBFPricing;
  const stock={three:{max:Math.max(0,this.config.three.max-threeOwned),cents:bf.price(this.config.three.id,this.config.three.price)},five:{max:Math.max(0,this.config.five.max-fiveOwned),cents:bf.price(this.config.five.id,this.config.five.price)}};
  return {bottles,capacity,offer:chooseStands(bottles,capacity,stock)};
 }
 fill(text,values){return Object.entries(values).reduce((s,[k,v])=>s.replaceAll('__'+k+'__',String(v)),text);}
 render() {
  if(!window.TeaballsBFPricing?.active()){this.hidden=true;return;}
  const {bottles,capacity,offer}=this.plan(this.cart);
  this.hidden=bottles<3 || !offer || (!offer.count && !capacity);
  if(this.hidden)return;
  this.input.checked=!offer.count;
  this.input.disabled=busy || Boolean(this.uncertain) || !offer.count;
  this.querySelector('[data-stand-title]').textContent=offer.count?this.labels.title:this.labels.ready;
  const mix=[offer.three?offer.three+' × '+this.labels.three:'',offer.five?offer.five+' × '+this.labels.five:''].filter(Boolean).join(' + ');
  this.querySelector('[data-stand-description]').textContent=(mix?mix+' · ':'')+this.fill(this.labels.capacity,{capacity:capacity+offer.addedCapacity,bottles});
  const bf=window.TeaballsBFPricing;
  const benefit=this.querySelector('[data-stand-benefit]');
  benefit.textContent=offer.count?((offer.three?bf.rate(this.config.three.id)===5:true)&&(offer.five?bf.rate(this.config.five.id)===5:true)?this.labels.benefit:''):this.labels.existing;
  const price=this.querySelector('[data-stand-price]');price.textContent=offer.count?'+'+bf.money(offer.cents):'';
  const was=this.querySelector('[data-stand-was]'), original=offer.three*this.config.three.price+offer.five*this.config.five.price;
  was.hidden=!offer.count||original<=offer.cents;was.textContent=bf.money(original);
 }
 async add() {
  if(busy || this.uncertain || !this.input.checked)return;
  busy=true;this.input.disabled=true;
  const status=this.querySelector('[data-stand-status]');status.hidden=false;status.textContent=this.labels.loading;
  try {
   const response=await fetch((window.Shopify?.routes?.root||'/')+'cart.js',{headers:{Accept:'application/json'},cache:'no-store'});
   if(!response.ok)throw new Error();
   const fresh=await response.json(), {bottles,offer}=this.plan(fresh);
   if(bottles<3||!offer?.count){this.cart=fresh;status.hidden=true;return;}
   const items=[];if(offer.three)items.push({id:Number(this.config.three.id),quantity:offer.three});if(offer.five)items.push({id:Number(this.config.five.id),quantity:offer.five});
   const {addPurchase}=await import(this.dataset.coreUrl);
   this.cart=await addPurchase(items);status.hidden=true;
  } catch(error){
   this.input.checked=false;this.input.disabled=Boolean(error.uncertain);status.textContent=error.uncertain?this.labels.uncertain:this.labels.error;this.uncertain=Boolean(error.uncertain);
  } finally {busy=false;if(!this.uncertain)this.render();}
 }
}
if(!customElements.get('teaballs-cart-stands'))customElements.define('teaballs-cart-stands',TeaballsCartStands);
